import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { I18n } from "aws-amplify/utils";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

const ConfirmSaveSimulationModal = ({ open, onClose, onSubmit }) => {
  const dataDaPassare = localStorage.getItem("simulationData");
  const location = useLocation();
  const initialFormData = {
    //dati iniziali per il form
    description: "",
    owner1: "",
    owner2: "",
    owner3: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({ owner1: "", owner2: "", owner3: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const emailRegex = /^[^\s@]+@[^\s#]+\.[^\s@]+$/;
    const newErrors = { owner1: "", owner2: "", owner3: "", description:"" };
    if(!formData.description||formData.description.trim()===""){
      newErrors.description="Required"
    }
    const owners = ["owner1", "owner2", "owner3"].map((key) => ({
      key,
      value: formData[key],
    }));

    //validazione formato
    owners.forEach(({ key, value }) => {
      if (value && !emailRegex.test(value)) {
        newErrors[key] = "Invalid email";
      }
    });

    const nonEmptyOwners = owners.filter(({ value }) => value);
    const values = nonEmptyOwners.map((o) => o.value);
    const duplicates = values.filter((val, i, arr) => arr.indexOf(val) !== i);

    nonEmptyOwners.forEach(({ key, value }) => {
      if (duplicates.includes(value)) {
        newErrors[key] = "Email must be unique";
      }
    });
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((msg) => msg);
    if (hasErrors) return;
    onSubmit(formData); //i dati vengono superati solo dopo che sono stati effettuati i controlli
    onClose();
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiDialog-paper": {
            width: "90%",
            maxWidth: "none",
            borderRadius: "1rem",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "24px" }}>
          {I18n.get("Save new simulation")}
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              mb: 1,
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <TextField
                label="Description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                fullWidth
                required
                error={!!errors.description}
                helperText={errors.description}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
              {" "}
              {/** seconda riga */}
              <TextField
                label="Owner 1"
                name="owner1"
                value={formData.owner1}
                onChange={handleChange}
                error={!!errors.owner1}
                helperText={errors.owner1}
              />
              <TextField
                label="Owner 2"
                name="owner2"
                value={formData.owner2}
                onChange={handleChange}
                error={!!errors.owner2}
                helperText={errors.owner2}
              />
                <TextField
                  label="Owner 3"
                  name="owner3"
                  value={formData.owner3}
                  onChange={handleChange}
                  error={!!errors.owner3}
                  helperText={errors.owner3}
                />
              </Box>
            </Box>
          <DialogActions>
            <Button onClick={onClose} color="secondary">
              {I18n.get("Close")}
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              sx={{
                backgroundColor: "rgb(52, 71, 103)",
                color: "rgb(255, 255, 255)",
                "&:hover": {
                  backgroundColor: "rgb(40, 55, 80)",
                },
              }}
            >
              {I18n.get("Save")}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default ConfirmSaveSimulationModal;
